/**
 * useConnectivity — thin wrapper around ConnectivityContext for backward compat.
 * All components import from here; the source of truth lives in the context.
 */
import { useConnectivityCtx } from '@/contexts/ConnectivityContext';

export const useConnectivity = () => useConnectivityCtx();
